import { getData, postData, deleteData, putData } from '../services/api';

export const getFeed = (page = 1, limit = 10) => {
    return getData(`/api/social/feed?page=${page}&limit=${limit}`);
};

export const createPost = (formData) => {
    // Note: formData should be used for multipart/form-data
    return postData('/api/social/posts', formData);
};

export const toggleLike = (postId) => {
    return postData(`/api/social/posts/${postId}/like`, {});
};

export const getPostComments = (postId) => {
    return getData(`/api/social/posts/${postId}/comments`);
};

export const addComment = (postId, content, parentId = null) => {
    return postData(`/api/social/posts/${postId}/comments`, { content, parentId });
};

export const getUserProfile = (userId) => {
    return getData(`/api/social/users/${userId}/profile`);
};

export const getUserPosts = (userId, page = 1) => {
    return getData(`/api/social/users/${userId}/posts?page=${page}`);
};

export const toggleFollow = (userId) => {
    return postData(`/api/social/users/${userId}/follow`, {});
};

export const searchUsers = (query) => {
    return getData(`/api/social/users/search?query=${query}`);
};

export const repostPost = (postId) => {
    return postData(`/api/social/posts/${postId}/repost`, {});
};

export const deletePost = (postId) => {
    return deleteData(`/api/social/posts/${postId}`);
};

export const reportPost = (postId, reason) => {
    return postData(`/api/social/posts/${postId}/report`, { reason });
};

// ─── Connect-only Social Handle ──────────────────────────────────────────────
export const getMySocialHandle = () => {
    return getData('/api/social/me/handle');
};

export const updateSocialHandle = (handle) => {
    return putData('/api/social/me/handle', { handle });
};
